<template>
    <div>
        <template v-if="detailedItem.interface_version == 2 && !detailedItem.reference_property_type_id">
            <div class="d-flex justify-content-between flex-wrap mb-2 pt-2 pb-2">
                <div>
                    <h5>Заказ #{{ detailedItem.order_id }} . {{ detailedItem.service_name }}</h5>
                </div>
                <span class="text-bold-size-13 text-secondary" v-if="!detailedItem.reference_property_type_id">
                    <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                    <span class="font-weight-light">{{ getManagerName() }}</span>
                </span>
            </div>
        </template>

        <template v-else>
            <div>
                <div class="d-flex justify-content-between flex-wrap mb-3">
                    <div>
                        <h5>Заказ #{{ detailedItem.order_id }}. {{ detailedItem.service_name }}{{ nameOfType() }}</h5>
                    </div>
                </div>

                <div
                    v-if="!dataOverlay"
                    class="row active-panel-block align-items-center m-0"
                >
                    <div class="active-panel-block_icon">
                        <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
                    </div>
                    <div class="active-panel-block_one">
                        <span class="text-bold-size-13 text-secondary">
                            <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                            <span class="font-weight-light mr-2">{{ getManagerName() }}</span>
                        </span>
                    </div>
                    <div class="text-bold-size-13 active-panel-block_two font-weight-bold text-uppercase">
                        <span class="font-weight-bold text-uppercase text-secondary"><i class="fas fa-info-circle text-orange mr-1"></i> Статус:</span>
                        <span class="font-weight-light text-uppercase mr-2">{{ getStatusName() }}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="detailedItem.interface_version == 2 && detailedItem.reference_property_type_id && currentOrderServiceComponent != ''">
            <div class="interface_v2 my-4">
                <component
                    :is="currentOrderServiceComponent"
                    :detailedItem="detailedItem"
                    :saveMode="saveMode"
                    :filteredDocs="filteredDocs"
                    :obshayaInfo="false"
                    :timelinePostavki="false"
                    :defaultVisible="'etapy'"
                ></component>
                <div class="my-4">
                    <OrderServiceComments :orderServiceId="detailedItem.id" />
                </div>
            </div>
        </template>

        <template v-if="detailedItem.interface_version != 2">
            <div class="position-relative mt-3">
                <b-table-simple small caption-top borderless stacked class="service-properties-table">
                    <b-thead>
                        <b-tr>
                            <b-th
                                v-for="item in detailedItem.data"
                                :key="item.id"
                            >{{ item.reference_service_property_name }}</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr>
                            <b-td
                                :stacked-heading="item.reference_service_property_name + ':'"
                                v-for="item in detailedItem.data"
                                :key="item.id"
                                :class="[item.group_id ? `grouped-prop grouped-prop-${item.reference_service_property_id}` : `prop-${item.reference_service_property_id}`]"
                                v-if="![243,244,249,250,251,254,255,258,259,327].includes(item.reference_service_property_id)"
                            >
                                <template>
                                    <template v-if="item.reference == 0">
                                        <template 
                                            v-if="
                                                !excludePropertyFromTextFiltering(item.reference_service_property_id) && 
                                                (item.reference_service_property_name.indexOf('Дата и время') !== -1 || 
                                                item.reference_service_property_name.indexOf('дата и время') !== -1)
                                            ">
                                                {{ (item.value || 'Нет данных') | formattedDateTime }}
                                        </template>
                                        <template 
                                            v-else-if="
                                                !excludePropertyFromTextFiltering(item.reference_service_property_id) && 
                                                (item.reference_service_property_name.indexOf('Срок действия') !== -1 || 
                                                item.reference_service_property_name.indexOf('Дата') !== -1 || 
                                                item.reference_service_property_name.indexOf('дата') !== -1)
                                            ">
                                                {{ (item.value || 'Нет данных') | formattedDate }}
                                        </template>
                                        <template v-else>
                                            {{ item.value || 'Нет данных' }}
                                        </template>
                                    </template>
                                    <template v-if="item.reference != 0">
                                        {{ getPropertyNameByValue(item.value) }}
                                    </template>
                                </template>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
        </template>

        <template v-if="detailedItem.interface_version == 2 && !currentOrderServiceComponent">
            <b-jumbotron>
                <template #header>
                    <h3 class="display-4">Услуга успешно создана</h3>
                </template>

                <template #lead>Данные по перевозке еще не сформированы.</template>
                <hr class="my-4">
                <p>Попробуйте посетить страницу позже.</p>
            </b-jumbotron>
        </template>
        <div>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </div>
</template>

<script>
import { SERVICE_TO_DOCUMENT } from '@/constants';
import { constantsAllReferenceProperties, defaultDataItems } from '@/mixins';
import OrderServiceComments from '@components/orders/OrderServiceCommentsClient.vue';
import TemplateFCL from '@components/orders/orderServiceTemplate/v2/TemplateFCLClient.vue';
import TemplateRFCL from '@components/orders/orderServiceTemplate/v2/TemplateRFCLClient.vue';
import TemplateAIR from '@components/orders/orderServiceTemplate/v2/TemplateAIRClient.vue';
import TemplateFTL from '@components/orders/orderServiceTemplate/v2/TemplateFTLClient.vue';
import TemplateRUS from '@components/orders/orderServiceTemplate/v2/TemplateRUSClient.vue';

export default {
    props: {
        order_id: { type: Number|String, required: true },
        reference_service_id: { type: Number|String, required: true },
    },
    mixins: [
        constantsAllReferenceProperties,
        defaultDataItems
    ],
    components: {
        OrderServiceComments,
        TemplateFCL,
        TemplateRFCL,
        TemplateAIR,
        TemplateFTL,
        TemplateRUS
    },
    data() {
        return {
            dataOverlay: true,
            detailedItem: {
                order_id: '',
                service_name: '',
                data: [],
                users: [],
                documents: [],
                company_documents: [],
            },
            saveMode: false,
            isDataRefreshing: false,
            actionReferenceProperties: {
                253: {
                    control_ids: [253],    // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                    readonly: false,
                    increment_id: 252       // Счетчик полей в БД
                },
                257: {
                    control_ids: [257, 258, 259],    // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номер ДТ',
                    readonly: false,
                    increment_id: 256       // Счетчик полей в БД
                },
                274: {
                    control_ids: [274],     // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номер транспортной накладной (BL, CMR, MAWB)',
                    readonly: false,
                    increment_id: 273       // Счетчик полей в БД
                },
                276: {
                    control_ids: [276],        // See reference_properties table
                    count: 0,
                    type: 'group',
                    create_doubles: true,
                    default_name: 'Номера транспортного средства: АВТО, ЖД, МОРЕ - номер тр.ср.; для АВИА - номер накладной',
                    readonly: false,
                    increment_id: 275       // Счетчик полей в БД
                },
                252: {
                    type: 'inline'
                },
                256: {
                    type: 'inline'
                },
                273: {
                    type: 'inline'
                },
                275: {
                    type: 'inline'
                },
            },
            requestDocuments: true,
            updateDocumentListCounter: 0,
            filteredDocs: [],
            currentOrderServiceComponent: '',
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.isDataRefreshing = true
            this.dataOverlay = true;
            api.call('get', `/api/orders/${this.order_id}/services/${this.reference_service_id}`).then(({data}) => {
                this.detailedItem = data;
                this.dataOverlay = false;
                this.isDataRefreshing = false;
                this.selectInterfaceTwoVersion();
                if (this.detailedItem.interface_version === 1) {
                    this.groupFields();
                }
                this.setDocumentRelation();

                this.$emit('setServiceInfo', data.id, data.data)
            })
        },
        setDocumentRelation() {
            let service_id = this.reference_service_id;
            if (SERVICE_TO_DOCUMENT[service_id] && this.detailedItem.company_documents.length > 0) {
                let find_document_by_property_id = SERVICE_TO_DOCUMENT[service_id];

                this.filteredDocs = this.detailedItem.company_documents.filter((doc) => doc.reference_document_type_id == find_document_by_property_id)

                this.detailedItem.company_documents.forEach((document, index) => {
                    // @TODO: ПЕРЕДЕЛАТЬ, ОРИЕНТИРОВАТЬСЯ НА ИНДЕКСЫ - ПЛОХО
                    if ((typeof find_document_by_property_id === 'string' && find_document_by_property_id.indexOf(document.reference_document_type_id, 0) != -1)
                        || find_document_by_property_id == document.reference_document_type_id) {
                        if (!this.detailedItem.data || !this.detailedItem.data[0] || !this.detailedItem.data[1]) {
                            this.detailedItem.data = { 
                                "0": {
                                    value: '' 
                                },
                                "1": {
                                    value: '' 
                                },
                            };
                        }
                        
                        this.detailedItem.data[0].value = !this.detailedItem.data[0].value ? document.name : this.detailedItem.data[0].value;
                        this.detailedItem.data[1].value = !this.detailedItem.data[1].value ? document.date_of_document : this.detailedItem.data[1].value;
                    }
                })
            }
        },
        selectInterfaceTwoVersion() {
            if (this.detailedItem.interface_version == 2 && this.detailedItem.reference_property_type_id) {
                switch (this.detailedItem.reference_property_type_id) {
                    // FCL/LCL – мультимодальная
                    case 565:
                        this.currentOrderServiceComponent = TemplateFCL;
                        break;
                    // RFCL/RLCL – прямое ЖД
                    case 566:
                        this.currentOrderServiceComponent = TemplateRFCL;
                        break;
                    // FTL/LTL  - международная автоперевозка
                    case 567:
                        this.currentOrderServiceComponent = TemplateFTL;
                        break;
                    // AIR – авиа
                    case 568:
                        this.currentOrderServiceComponent = TemplateAIR;
                        break;
                    // RUS – внутрироссийская перевозка
                    case 569:
                        this.currentOrderServiceComponent = TemplateRUS;
                        break;
                }
            }
        },
        getPropertyNameByValue(value) {
            let result = 'Нет данных'
            if (value && this.referencePropertiesList[value]) {
                result = this.referencePropertiesList[value]['text']
            }
            return result
        },
        getManagerName() {
            let name = "Не назначен"
            if (this.detailedItem.users.length > 0) {
                name = this.detailedItem.users[0].name
            }
            return name
        },
        getStatusName() {
            let name = "Не известен"
            if (this.detailedItem.status && this.detailedItem.status.name) {
                name = this.detailedItem.status.name
            }
            return name
        },
        groupFields() {
            const sortServicePropertiesByOrderNumber = (a, b) => {
                return (a['reference_service_property_ordering_number'] > b['reference_service_property_ordering_number'] && 1) ||
                (a['reference_service_property_ordering_number'] === b['reference_service_property_ordering_number'] ? 0 : -1)
            }

            const groupServicePropertiesId = (a, b) => {
                return (a['reference_service_property_id'] > b['reference_service_property_id'] && 1) ||
                    (a['reference_service_property_id'] === b['reference_service_property_id'] ? 0 : -1)
            }

            const groupServicePropertiesByGroupId = (a, b) => {
                a['group_id'] = a['group_id'] ? a['group_id'] : 0
                b['group_id'] = b['group_id'] ? b['group_id'] : 0

                return (a['group_id'] > b['group_id'] && 1) ||
                    (a['group_id'] === b['group_id'] ? 0 : -1)
            }

            this.detailedItem.data = this.detailedItem.data.sort(groupServicePropertiesId)
            this.detailedItem.data = this.detailedItem.data.sort(groupServicePropertiesByGroupId)
            this.detailedItem.data = this.detailedItem.data.sort(sortServicePropertiesByOrderNumber)

            this.actionReferenceProperties[253].count = 0
            this.actionReferenceProperties[257].count = 0
            this.actionReferenceProperties[274].count = 0
            this.actionReferenceProperties[276].count = 0
            this.detailedItem.data.forEach((item, index) => {
                let nowPropertyId = item.reference_service_property_id
                if (this.actionReferenceProperties[nowPropertyId]) {
                    // If we have counter - increase it
                    if (this.actionReferenceProperties[nowPropertyId].count >= 0) {
                        item.reference_service_property_name = this.actionReferenceProperties[nowPropertyId].default_name
                        this.actionReferenceProperties[nowPropertyId].count++
                        item.reference_service_property_name += ' ' + this.actionReferenceProperties[nowPropertyId].count
                    }
                }
            })
            // update increments ids counts
            this.detailedItem.data.forEach((item, index) => {
                let nowPropertyId = item.reference_service_property_id
                switch(nowPropertyId) {
                    case this.actionReferenceProperties[253].increment_id:
                        item.value = this.actionReferenceProperties[253].count
                        break
                    case this.actionReferenceProperties[257].increment_id:
                        item.value = this.actionReferenceProperties[257].count
                        break
                    case this.actionReferenceProperties[274].increment_id:
                        item.value = this.actionReferenceProperties[274].count
                        break
                    case this.actionReferenceProperties[276].increment_id:
                        item.value = this.actionReferenceProperties[276].count
                        break
                }
            })
        },
        excludePropertyFromTextFiltering(property_id) {
            let excludeArray = [253, 276];
            return excludeArray.includes(property_id) ? true : false;
        },
        nameOfType() {
            if (this.detailedItem.interface_version != 1) {
                if (this.detailedItem.reference_property_type && this.detailedItem.reference_property_type.name) {
                    return `. ${this.detailedItem.reference_property_type.name}`;
                }
            } 

            return '';
        },
    }
}
</script>